<template>
    <main class="main promo d-flex">
        <div class="container">
            <page-preloader
                :is-loading="newPromoActivationStatus === 'loading'"
                mode="wrapper"
            >
                <div>
                    <add-new-promo />
                </div>
                <template
                    v-if="newPromoActivationStatus === 'loading'"
                    v-slot:loaderDescription
                >
                    <div class="py-4">
                        <h5>
                            Trwa proces dodawania i aktywacji nowej promocji.
                        </h5>
                    </div>
                </template>
            </page-preloader>
        </div>
    </main>
</template>

<script>
import AddNewPromo from '@/components/promotions/addNewPromo/AddNewPromo'

export default {
    components: {
        AddNewPromo
    },
    computed: {
        newPromoActivationStatus() {
            return this.$store.getters.getNewPromoActivationStatus
        }
    }
}
</script>
